import { computed, defineComponent, onMounted, reactive, ref, watch ,onActivated} from "vue";
import { OrderService } from "@/views/purchase/order/order.service";
import { hmdConfirm } from "@/dialog/index";
import { OrderPageReq } from "@/views/purchase/order/order.interface";
import {Form} from "ant-design-vue"
import { bindEmitter } from "@/utils/emitter";
export default defineComponent({
  isGlobal: true,
  name: "PurchaseOrderSelect",
  props: {
    value: { type: String, default: undefined },
    validStatus: { type: String, default: "ysx" },
    storageStatus: { type: String, default: "wrk,bfrk" },
    defaultName: { type: String, default: "" },
    validate:{
      type:Boolean,
      default:true
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["clear","update:value", "change","update:projectId","update:projectName","update:partyBCooperationCompanyId","update:partyBCooperationCompanyName","update:remark"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    let isError = ref(false);
    const valueName = ref('');
    const { data: dataSource, loading, run, refresh, pagination } = OrderService.usePageApi();
    const queryRef = reactive(new OrderPageReq());
    queryRef.storageStatus = props.storageStatus;
    queryRef.validStatus = props.validStatus;
    queryRef.current=1;
    queryRef.size=1;
    run(queryRef);
    bindEmitter("trigger-form-custom-validator", async () => {
      if(props.validate){
        formItemContext.onFieldChange();
        if(props.value){
          isError.value=false;
        }else{
          isError.value=true;
        }
      }
    });
    bindEmitter("trigger-keepalive-form-reset", () => {
      isError.value=false;
    });
    const checkValue =async (n)=>{
      if(n){
        queryRef.id = n;
        await run(queryRef);
        // console.log('dataSource',dataSource.value)
        if(dataSource.value?.length>0){
          const info = dataSource.value[0] as any;
          emit("update:value",n);
          emit("change",info);
          emit("update:projectId",info.projectId);
          emit("update:projectName",info.projectName);
          emit("update:partyBCooperationCompanyId",info.partyBCooperationCompanyId);
          emit("update:partyBCooperationCompanyName",info.partyBCooperationCompanyName);
          emit("update:remark",info.remark)
          valueName.value = info.name;
        }
        if(props.validate){
          formItemContext.onFieldChange();
          isError.value=false;
        }
      }else{
        emit("update:value",undefined);
        emit("change",{});
        emit("update:projectId",undefined);
        emit("update:projectName",undefined);
        emit("update:partyBCooperationCompanyId",undefined);
        emit("update:partyBCooperationCompanyName",undefined);
        emit("update:remark",undefined)
        if(props.validate){
          formItemContext.onFieldChange();
          isError.value=true;
        }
      }
    }
    watch(()=>props.value,(n)=>{
      checkValue(n)
    });
    onMounted(()=>{
      checkValue(props.value);
      isError.value = false;
    })
    onActivated(()=>{
      isError.value = false;
    })
    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          validStatus:props.validStatus,
          storageStatus:props.storageStatus,
          addRightBizType:props.addRightBizType
        },
        confirm:({res})=>{
          const {id,projectId,projectName,partyBCooperationCompanyId,partyBCooperationCompanyName,remark,name} = res;
          if(id!==props.value&&props.value&&id){
            emit("clear");
          }
          emit("update:value",id);
          emit("change",res);
          emit("update:projectId",projectId);
          emit("update:projectName",projectName)
          emit("update:partyBCooperationCompanyId",partyBCooperationCompanyId);
          emit("update:partyBCooperationCompanyName",partyBCooperationCompanyName);
          emit("update:remark",remark)
          valueName.value = name;
        }
      });
    };
    const removeSelected = () => {
      emit("update:value", undefined);
      emit("change", undefined);
      emit("clear")
    };


    return {
      showModal,
      valueName,
      isError,
      removeSelected
    };
  },
});
